import { TestApp } from "./apps/TestApp.js";

export class Application {

    constructor(private _element: HTMLDivElement) {
        e5.console.log("[eventfive.aheads.focke] [Application]");

        this.init();
    }

    private async init() {
        const isRuntime = Boolean(window.api);
        const debug = e5.console.enabled || e5.Url.params.has("debug");
        e5.console.enabled = debug;
        
        let assetsUrl = this._element.getAttribute("data-base") + "/assets";

        new TestApp({
            element: this._element,
            assetsUrl: assetsUrl
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    var e = document.querySelector<HTMLDivElement>("#app");
    if (e) {
        new Application(e);
    }
});